import { render, staticRenderFns } from "./bannerleft.vue?vue&type=template&id=3aaedc3d&scoped=true&"
import script from "./bannerleft.js?vue&type=script&lang=js&"
export * from "./bannerleft.js?vue&type=script&lang=js&"
import style0 from "./bannerleft.vue?vue&type=style&index=0&id=3aaedc3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaedc3d",
  null
  
)

export default component.exports